import PrintShell, { PrintField, PrintRow, PrintSectionHeader, PrintTextBlock } from '../../../components/print/PrintShell';

export default function BulletinPrintTemplate({ bulletin: b }) {
  if (!b) return null;
  return (
    <PrintShell printClass="bulletin-print-only" formTitle="BULLETIN">
      <PrintSectionHeader title="Bulletin" />
      <PrintRow fields={[
        { label: 'Title', value: b.title },
        { label: 'Date', value: b.created_at, flex: 0.6 },
      ]} />
      <PrintTextBlock label="Description" value={b.description} />
      <PrintField label="Document" value={b.document} />
    </PrintShell>
  );
}
